export default __webpack_public_path__ + "static/media/ava1.c56d12da.png";